module.exports = __webpack_public_path__ + "media/payment_methods/american_express-b3d28046.svg";